import { useQuery } from "@tanstack/react-query";

import type { Customer } from "@shared/schemas/entities";

import { apiGet } from "@/lib/api/client";
import { queryKeys } from "@/lib/query/keys";

// Phase 5.112 — Volltext-Suche fuer die CustomersListPage. Bis zu 50
// Treffer pro Query. Disabled bei <1 Zeichen (Empty-Query) — analog
// useProductSearch-Pattern, das ab 2 Zeichen feuert. Wir nehmen 1 Zeichen
// als Untergrenze, weil ein einzelnes Initial („C") fuer Adressbuch-
// Lookups schon nuetzlich ist (Daniel-Use-Case: „auf Buchstabe filtern").

interface CustomerSearchResponse {
  ok: true;
  data: Customer[];
}

export function useCustomerSearch(query: string, enabled = true) {
  const trimmed = query.trim();
  return useQuery({
    queryKey: queryKeys.customers.search(trimmed),
    enabled: enabled && trimmed.length >= 1,
    staleTime: 30_000,
    queryFn: async () => {
      const res = await apiGet<CustomerSearchResponse>(
        `/api/customers/search?q=${encodeURIComponent(trimmed)}`,
      );
      return res.data;
    },
  });
}
